import Qualification from './Qualification';

export default Qualification;
